import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconPlus = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M31.488 1.913c-.527.171-1.059.6-1.28 1.033a2.7 2.7 0 0 0-.186.604c-.05.265-.07 4.265-.07 13.39v13.012H16.94c-9.125 0-13.125.02-13.39.07-.677.125-1.162.488-1.49 1.114-.242.46-.244 1.193-.005 1.696.303.638.798 1.017 1.495 1.146.265.05 4.265.07 13.39.07h13.012V47.06c0 9.125.02 13.125.07 13.39.087.474.234.761.548 1.079.78.788 2.08.788 2.86 0 .314-.318.46-.605.548-1.079.05-.265.07-4.265.07-13.39V34.048H47.06c9.125 0 13.125-.02 13.39-.07.473-.087.761-.233 1.079-.548.788-.78.788-2.08 0-2.86-.318-.314-.606-.46-1.079-.548-.265-.05-4.265-.07-13.39-.07H34.048V16.94c0-9.125-.02-13.125-.07-13.39q-.193-1.047-1.146-1.492c-.372-.174-1.035-.246-1.344-.145" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconPlus.displayName = 'IconPlus';